import { __, get, hasIn, invoke, invokeArgs, set } from 'lodash/fp';

interface CreateEnvironmentServiceOptions {
    context: Window;
}

// Can be removed after this is solved: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/48181
const mutableSet: typeof set = (set as $TSFixMe).convert({ immutable: false });
type MutableSetParameters = Parameters<typeof mutableSet>;

export const createEnvironmentService = ({ context }: CreateEnvironmentServiceOptions) => ({
    hasIn: hasIn(__, context),
    get: get(__, context),
    set: (path: MutableSetParameters[0], value: MutableSetParameters[1]) => mutableSet(path, value, context),
    invoke: invoke(__, context),
    invokeArgs: invokeArgs(__, __, context),
});

export type EnvironmentService = ReturnType<typeof createEnvironmentService>;
